import { createContext, useContext, type ReactNode } from 'react'
import { useOrganizationCurrency } from 'src/shared/hooks/useOrganizationCurrency'

const OrderTableCurrencyContext = createContext<string | null>(null)

/**
 * Labels the order table's amounts with this currency instead of the viewer's
 * organization currency. For views whose prices are already converted to the
 * quote's own currency (the public proposal page).
 */
export const OrderTableCurrencyProvider = ({
  currency,
  children,
}: {
  currency: string
  children: ReactNode
}) => (
  <OrderTableCurrencyContext.Provider value={currency}>
    {children}
  </OrderTableCurrencyContext.Provider>
)

// eslint-disable-next-line react-refresh/only-export-components
export const useOrderTableCurrency = () => {
  const override = useContext(OrderTableCurrencyContext)
  const organizationCurrency = useOrganizationCurrency()
  return override ?? organizationCurrency
}
